export const MercadoPagoPaymentResult = 'payment';
export const MercadoPagoLinkResult = 'link';

export const MercadoPago = 'mercado-pago';

export const MercadoPagoPaymentResultView = `/${MercadoPago}/${MercadoPagoPaymentResult}`;
export const MercadoPagoLinkResultView = `/${MercadoPago}/${MercadoPagoPaymentResult}`;
